// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let PasswordRecoveryChangeResponse = function (fieldSet)
{
    this.Code = Message.CODE_RECOVERY_CHANGE_RESPONSE;
    PFixMessage.call(this, fieldSet);
}
PasswordRecoveryChangeResponse.prototype = Object.create(PFixMessage.prototype);


PasswordRecoveryChangeResponse.prototype.getStatus = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_CHANGE_PWD_STATUS);
}

PasswordRecoveryChangeResponse.prototype.getMinLength = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_MIN_PASSWORD_LENGTH);
}

